import User from './UserApi'
import Client from './ClientApi'
import Contract from './ContractApi'
import Litigation from './LitigationApi'

import Supplier from './SupplierApi'
import Bill from './BillApi'
import Tag from './TagApi'

import FinancialGatewayBalance from './FinancialGatewayApi'

export default{
  User,
  Client,
  Contract,
  Litigation,
  
  Supplier,
  Bill,
  Tag, 
  FinancialGatewayBalance
}